/* eslint-disable react/no-children-prop */
import { Stack } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { EmptyState } from '../../components/chat/EmptyState';
import { Message } from '../../components/chat/Message';
import { Notifications } from '../../components/chat/Notifications';
import { TypingIndicator } from '../../components/chat/TypingIndicator';
import ProjectContainer from '../../components/containers/ProjectContainer';
import { useChat } from '../../hooks/useChat';
import { Components as FormComponents } from '../Forms/styled';
import { PromptComponents } from './styled';
import { StreamedMessage } from '../../components/chat/StreamedMessage';
export interface IMessage {
  id: string;
  text: string;
  sender: 'user' | 'assistant';
}

export function Prompt() {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const {
    messages,
    notification,
    handleCloseNotification,
    form,
    saveChatConfig,
    setNotification,
    setMessages,
    isSaving,
    clearChat,
    systemPrompt,
  } = useChat();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <ProjectContainer title={'Prompt'}>
      <PromptComponents.Container>
        <PromptComponents.ChatContainer
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit();
          }}>
          <PromptComponents.ChatWrapper>
            <PromptComponents.MessagesContainer>
              {messages.length === 0 ? (
                <EmptyState />
              ) : (
                <>
                  {messages.map((message) => (
                    <Message key={message.id} message={message} />
                  ))}

                  <StreamedMessage
                    messages={messages}
                    systemPrompt={form.values.systemPrompt}
                    temperature={form.values.temperature}
                    status={form.status}
                    setNotification={setNotification}
                    setMessages={setMessages}
                    setStatus={form.setStatus}
                  />
                  <div ref={messagesEndRef} />
                </>
              )}
            </PromptComponents.MessagesContainer>

            <PromptComponents.InputContainer>
              <PromptComponents.MessageInput
                name='message'
                value={form.values.message}
                onChange={form.handleChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    form.handleSubmit();
                  }
                }}
                placeholder='Type your message here... (Press Enter to send, Shift+Enter for new line)'
              />
              <PromptComponents.SendButton type='submit' disabled={!form.values.message.trim().length}>
                Send
              </PromptComponents.SendButton>
            </PromptComponents.InputContainer>
          </PromptComponents.ChatWrapper>
          <PromptComponents.PromptContainer>
            <Stack direction='row' justifyContent='space-between' alignItems='center' gap={1}>
              <PromptComponents.NewChatButton type='button' onClick={clearChat}>
                New chat/prompt
              </PromptComponents.NewChatButton>

              <PromptComponents.NewChatButton
                type='button'
                onClick={() => {
                  saveChatConfig({
                    prompt: form.values.systemPrompt,
                    temperature: form.values.temperature,
                  });
                }}
                disabled={isSaving || form.values.systemPrompt == systemPrompt}>
                {isSaving ? 'Saving...' : 'Save system prompt'}
              </PromptComponents.NewChatButton>
            </Stack>
            <PromptComponents.PromptLabel htmlFor='systemPrompt'>System Prompt</PromptComponents.PromptLabel>
            <PromptComponents.PromptTextarea
              id='systemPrompt'
              placeholder='Type your system prompt here...'
              name='systemPrompt'
              value={form.values.systemPrompt}
              onChange={form.handleChange}
            />

            <PromptComponents.TemperatureContainer>
              <PromptComponents.TemperatureLabel htmlFor='temperature'>Temperature</PromptComponents.TemperatureLabel>
              <PromptComponents.TemperatureInput
                id='temperature'
                type='number'
                name='temperature'
                min='0'
                max='2'
                step='0.1'
                placeholder='1.0'
                value={form.values.temperature}
                onChange={(e) => form.setFieldValue('temperature', parseFloat(e.target.value))}
              />
              <PromptComponents.HelperText>
                Value between 0 and 2, where 0 is very factual and non creative and 2 is are very creative and
                incoherent
              </PromptComponents.HelperText>
            </PromptComponents.TemperatureContainer>
          </PromptComponents.PromptContainer>
        </PromptComponents.ChatContainer>
      </PromptComponents.Container>
      <Notifications
        message={notification.message}
        severity={notification.severity}
        open={notification.open}
        onClose={handleCloseNotification}
      />
    </ProjectContainer>
  );
}
